export const BASE_URL = 'http://35.179.21.19:3007/api/v1'